import LogicaAPI from "./logicaapi";

class LinkSet extends LogicaAPI {
  linkSet(id, offset = 0, limit = 10) {
    const params = {
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
      with_total_count: true,
      from: offset,
      limit,
    };
    return this.get(`/api/v1/link_sets/${id}`, {params});
  }
}
export default LinkSet;
